import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BookstoreRoutingModule } from './bookstore-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { PackageSetupComponent } from './package-setup/package-setup.component';
import { IssuePackageComponent } from './issue-package/issue-package.component';
import { StockInformationComponent } from './stock-information/stock-information.component';
import { BookRequestComponent } from './book-request/book-request.component';
import { RequestApprovalAuthorityComponent } from './request-approval-authority/request-approval-authority.component';
import { BookRequestIssueComponent } from './book-request-issue/book-request-issue.component';
import { StationarySellReportComponent } from './stationary-sell-report/stationary-sell-report.component';
import { IssueItemDayWiseReportComponent } from './issue-item-day-wise-report/issue-item-day-wise-report.component';
import { PackagePrintComponent } from './package-print/package-print.component';
import { IssueItemPrintComponent } from './issue-item-print/issue-item-print.component';


@NgModule({
  declarations: [PackageSetupComponent, IssuePackageComponent, StockInformationComponent, 
    BookRequestComponent, RequestApprovalAuthorityComponent, BookRequestIssueComponent, 
    StationarySellReportComponent, IssueItemDayWiseReportComponent, PackagePrintComponent, 
    IssueItemPrintComponent],
  imports: [
    CommonModule,
    BookstoreRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
  ]
})
export class BookstoreModule { }
